<template>
  <div class="standing-table-container">
    <div class="standing-title">{{ $t("STANDINGS") }}</div>
    <div v-for="(level1, index) in standingTableList" :key="index">
      <div class="match-table__header-title">{{ level1.displayGroupName }}</div>
      <div class="match-table match-table__header">
        <div class="display-flex">
          <!-- <div class="match-table__index">#</div> -->
          <div class="match-table__club">
            <div>{{ $t("TEAM") }}</div>
          </div>
        </div>
        <div class="match-table__score">
          <div>MP</div>
          <div>W</div>
          <div>D</div>
          <div>L</div>
          <div>F</div>
          <div>A</div>
          <div>+-</div>
          <div>P</div>
        </div>
      </div>
      <Navigation
        :id="o.teamId"
        :category="'team'"
        :name="o.teamName"
        class="match-table"
        v-for="(o, index2) in level1.total"
        :key="index2"
      >
        <div class="display-flex-center">
          <div :class="`match-table__index ${o.promotionColor}`">#</div>
          <div class="match-table__club">
            <div class="match-table__club-icon">
              <Icon :logoUrl="o.logo"></Icon>
            </div>
            <div>{{ o.teamName }}</div>
          </div>
        </div>
        <div class="match-table__score">
          <div>{{ o.gamesPlayed === null ? "-" : o.gamesPlayed }}</div>
          <div>{{ o.gamesWon === null ? "-" : o.gamesWon }}</div>
          <div>{{ o.gamesDrawn === null ? "-" : o.gamesDrawn }}</div>
          <div>{{ o.gamesLost === null ? "-" : o.gamesLost }}</div>
          <div>{{ o.gamesScored === null ? "-" : o.gamesScored }}</div>
          <div>{{ o.gamesAgainst === null ? "-" : o.gamesAgainst }}</div>
          <div>{{ o.goalsDifference === null ? "-" : o.goalsDifference }}</div>
          <div>{{ o.points === null ? "-" : o.points }}</div>
        </div>
      </Navigation>
    </div>
    <div></div>
    <div class="match-table__tips-container">
      <div
        class="match-table__tips-wrapper"
        v-for="(o, index) in promotionTableList.promotionList"
        :key="index"
      >
        <div class="match-table__tips">
          <div class="match-table__index" :class="o.color">#</div>
          <div>{{ o.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isWorldCup: false,
      rankingTable: {
        isShow: false,
        isLoading: false,
      },
      standingTableList: [],
      promotionTableList: [],
    };
  },
  mounted() {
    this.getSGFCSoccerLeagueRankingData();
  },
  methods: {
    ...mapActions(["getSGFCSoccerLeagueRanking"]),
    //handle ranking table
    async getSGFCSoccerLeagueRankingData() {
      let params = {
        leagueIdList: 1,
      };
      this.standingTableList = ["a"];
      const result = await this.getSGFCSoccerLeagueRanking(params);

      if (result.result.length === 0) {
        this.rankingTable.isShow = false;
      } else {
        this.rankingTable.isShow = true;

        this.standingTableList = result.result;
        this.promotionTableList = this.standingTableList[0];
      }
    },
  },
};
</script>

<style scoped>
.standing-title {
}
.standing-table-container {
  background: var(--color-background-default-secondary);
  padding: 16px;
  border-radius: 16px;
}
.match-table__header-title {
  background: #212b30;
  border-radius: 8px 8px 0px 0px;
  padding: 14px 12px;
  font-size: 12px;
  font-family: var(--weight-700);
  letter-spacing: 0.2px;
}
.match-table__main-group-stage-title {
  font-size: 1.125rem;
  font-family: var(--weight-700);
  margin-bottom: 0.5rem;
}
.match-table__header-country__wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.88rem;
  margin-bottom: 0.4rem;
}
.match-table__header {
  /* background-color: #212B30; */
}
.match-table-wc__header {
  background-color: #212b30;
  font-family: var(--weight-700);
  font-size: 0.875rem;
  padding: 0.875rem 0.75rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.match-table-wc__wrapper {
  margin-bottom: 1.5rem;
}
.match-table-wc__child-wrapper .match-table {
  border-bottom: 0;
  position: relative;
}
.match-table-wc__child-wrapper .match-table-row::after {
  content: "";
  width: calc(100% - 1.6rem);
  border-bottom: 1px solid #212b30;
  position: absolute;
  bottom: 0;
}
.match-table-wc__child-wrapper
  .match-table-row-wrapper
  a:last-of-type
  .match-table-row::after {
  border-bottom: none;
}
.match-table-wc__child-wrapper .match-table-row:hover::after {
  border-bottom: 1px solid var(--bg-hover);
}
.match-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #cfd9de;
  border-bottom: 1px solid #212b30;
  padding: 0.5rem 0.8rem;
  font-size: 0.6875rem;
  margin: 0 0.5rem;
  pointer-events: none;
}
.match-table:last-child {
  border-bottom: none;
  padding-bottom: 1rem;
}
.match-table.selected {
  background-color: #212b30;
  color: white;
  font-family: var(--weight-700);
}
.match-table:hover {
  background-color: var(--color-background-default-default);
}
.match-table__index {
  margin-right: 0.3rem;
  width: 1.1rem;
}
.color-1 {
  color: var(--color-icon-primary-active);
}
.color-2 {
  color: var(--secondary-400);
}
.color-3 {
  color: var(--tertiary-600);
}
.color-4 {
  color: var(--secondary-600);
}
.color-5 {
  color: var(--warning-600);
}
.color-p {
  color: #ffc0cb;
}
.color-r {
  color: var(--color-icon-error-active);
}
.color-g {
  color: #5cd66c;
}
.color-b {
  color: #2e8fef;
}
.color-y {
  color: #ffe570;
}

.match-table__club {
  display: flex;
  align-items: center;
  flex: 2;
  max-width: 13rem;
}

.match-table__club-icon {
  margin-right: 0.5rem;
}
.match-table__score {
  display: flex;
  width: 10rem;
  justify-content: space-between;
  text-align: center;
}
.match-table__score > div {
  flex: 1;
  margin: 0 0.15rem;
  min-width: 1.01rem;
}
.match-table__tips-container {
  background-color: var(--color-theme);
  padding: 0.25rem 0;
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.match-table__tips-wrapper {
  color: #cfd9de;
}
.match-table__tips {
  display: flex;
  flex-direction: row;
  margin: 0 1rem;
  padding: 0.25rem 0;
  font-size: 0.7rem;
}

@media (max-width: 1200px) {
  /* for test */
  .match-table__main-group-stage-title {
    font-size: 0.875rem;
  }
  .match-table__club {
    max-width: 10.5rem;
  }
}
</style>
